import {
    Cog6ToothIcon,
    PencilSquareIcon,
    UsersIcon,
    CurrencyYenIcon,
    UserIcon,
    BanknotesIcon,
    PaperAirplaneIcon,
    ShieldCheckIcon,
    ChartBarIcon,
    UserGroupIcon,
    BuildingOffice2Icon,
    WrenchScrewdriverIcon,
    BellIcon,
    ExclamationTriangleIcon,
} from '@heroicons/react/24/outline'

const menu = [
  {
    title: "กรอกข้อมูล",
    icon: PencilSquareIcon,
    path: "/keydata",
    roles: ['superuser','admin'],
  },
  {
    title: "ประกาศ",
    icon: BellIcon,
    path: "/notifications",
    roles: ['superuser','admin'],
  },
  {
    title: "เคสลูกค้า",
    icon: ExclamationTriangleIcon,
    path: "/case-ticket",
    roles: ['superuser','admin'],
  },
  {
    title: "ข้อมูลลูกค้า",
    icon: UsersIcon,
    roles: ['superuser','admin'],
    childrens: [
      {
        title: "ข้อมูลรายคน",
        path: "/customer-profile",
        roles: ['superuser','admin']
      },
      {
        title: "รายชื่อ Blacklist",
        path: "/blacklist",
        roles: ['superuser','admin']
      },
      {
        title: "รายชื่อ VIP",
        path: "/vipcustomerlist",
        roles: ['superuser','admin']
      },
      {
        title: "CRM ลูกค้า",
        path: "/crm",
        roles: ['superuser']
      },
      {
        title: "Order ลูกค้าใหม่",
        path: "/newprofileorder",
        roles: ['superuser']
      },
    ]
  },
  {
    title: "ตรวจสอบยอด",
    icon: ShieldCheckIcon,
    path: "/receiptissue",
    roles: ['superuser'],
  },
  {
    title: "รายการ",
    icon: CurrencyYenIcon,
    roles: ['superuser','admin'],
    childrens: [
      {
        title: "รายการล่าสุด",
        path: "/order",
        roles: ['superuser','admin']
      },
      {
        title: "สรุปรายการลูกค้า",
        path: "/admin/ordersummary",
        roles: ['superuser','admin', 'user'],
      },
      {
        title: "สรุปรายการ Admin",
        path: "/admin/ordersummaryadmin",
        roles: ['superuser','admin', 'user'],
      },
      {
        title: "รายการไม่มีค่าส่ง",
        path: "/ordernodelivery",
        roles: ['superuser','admin']
      },
      {
        title: "ฟอร์มฝากส่ง",
        path: "/admin/sendonly",
        roles: ['superuser','admin'],
      },
      {
        title: "รายการบิล Rakuten",
        path: "/bill",
        roles: ['superuser','admin'],
      },
      {
        title: "ประมูล Mercari",
        path: "/mercari",
        roles: ['superuser','admin'],
      },
      {
        title: "ต่อราคา Mercari",
        path: "/mercarichange",
        roles: ['superuser','admin'],
      },
      {
        title: "Mercari Admin",
        path: "/mercariadmin",
        roles: ['superuser','admin'],
      },
      {
        title: "ตรวจ Mercari Verify",
        path: "/mercari-verify",
        roles: ['superuser','admin'],
      },
      {
        title: "Mercari ไม่อนุมัติ",
        path: "/mercari-verify-rejected",
        roles: ['superuser','admin'],
      },
      {
        title: "รายการ หิ้วของ",
        path: "/handcarry",
        roles: ['superuser','admin'],
      },
      {
        title: "รายการ ไม่มีรูป",
        path: "/noconfirmimage",
        roles: ['superuser','admin'],
      },
      {
        title: "รูปยืนยันการซื้อ",
        path: "/purchase-image-list",
        roles: ['superuser','admin'],
      },
      {
        title: "สินค้าขนาดใหญ่",
        path: "/oversize",
        roles: ['superuser','admin'],
      },
      {
        title: "น้ำหนักเหมา",
        path: "/order/weightpricelist",
        roles: ['superuser','admin'],
      },
      {
        title: "ดำเนินการยกเลิก",
        path: "/refund?tab=cancel",
        roles: ['superuser','admin'],
      },
      {
        title: "Order ลูกค้าใหม่",
        path: "/neworder",
        roles: ['superuser','admin'],
      },
    ],
  },
  {
    title: "หลังบ้าน",
    icon: BuildingOffice2Icon,
    roles: ['superuser', 'admin'],
    childrens: [
      {
        title: "URL แอร์",
        path: "/backoffice/isairurl",
        roles: ['superuser', 'admin'],
      },
      {
        title: "สรุปเก็บเงินลูกค้า",
        path: "/backoffice/payment-summary-queue",
        roles: ['superuser', 'admin'],
      },
      {
        title: "Beam webhook ค้าง",
        path: "/backoffice/beam-webhook-replay",
        roles: ['superuser'],
      },
      {
        title: "ตามหาพัสดุ",
        path: "/backoffice/find-parcel",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ยืนยัน Orderer ค้าง",
        path: "/backoffice/pending-orderer-confirms",
        roles: ['superuser', 'admin'],
      },
      {
        title: "กำหนดชนิด หิ้วของ",
        path: "/handcarry-type-assignment",
        roles: ['superuser', 'admin'],
      },
      {
        title: "การรับของ Mercari",
        path: "/receive-mercari",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ตรวจสอบ Mercari",
        path: "/check-mercari",
        roles: ['superuser', 'admin'],
      },
      {
        title: "เติมเลขพัสดุญี่ปุ่น",
        path: "/addtracking",
        roles: ['superuser','admin'],
      },
    ],
  },
  {
    title: "เก็บเงิน",
    icon: BanknotesIcon,
    roles: ['superuser','admin'],
    childrens: [
      {
        title: "เก็บเงินรายคน",
        path: "/collectmoneyperson",
        roles: ['superuser','admin'],
      },
      {
        title: "เก็บเงินรอบเรือ",
        path: "/collectmoney",
        roles: ['superuser','admin'],
      },
      {
        title: "ติดตามค้างจ่าย",
        path: "/debt-follow-up",
        roles: ['superuser','admin'],
      },
    ],
  },
  {
    title: "รีพอร์ต",
    icon: ChartBarIcon,
    path: "/report",
    roles: ['superuser'],
  },
  {
    title: "การเงิน",
    icon: CurrencyYenIcon,
    roles: ['superuser'],
    childrens: [{
      title: "การแลกเงิน",
      path: "/exchangemoney/",
      roles: ['superuser']
      },
      {
        title: "โอนเงินคืน ลค",
        path: "/refund",
        roles: ['superuser', 'admin']
      },
      {
        title: "การกดเงิน",
        path: "/withdrawrecord",
        roles: ['superuser']
      },
      {
        title: "รายการค่าใช้จ่าย",
        path: "/expenserecord",
        roles: ['superuser']
      },
    ],
  },
  {
    title: "รอบเรือ",
    icon: PaperAirplaneIcon,
    roles: ['superuser','admin'],
    childrens: [{
      title: "ของถึง",
      path: "/weeklyship/arrival",
      roles: ['superuser','admin']
      },{
      title: "แจ้งของถึง (แอป)",
      path: "/weeklyship/platform-arrival",
      roles: ['superuser','admin']
      },{
      title: "ข้อมูลทั้งหมด",
      path: "/weeklyship",
      roles: ['superuser','admin']
      },{
      title: "นำเข้าข้อมูล",
      path: "/weeklyship/import",
      roles: ['superuser','admin']
      },
      {
        title: "จับคู่หาเจ้าของ",
        path: "/weeklyship/match",
        roles: ['superuser','admin']
      },
      {
        title: "หาเจ้าของจากรูปแกะกล่อง",
        path: "/weeklyship/unpack-match",
        roles: ['superuser','admin']
      },
      {
        title: "ใส่เลขพัสดุไทย",
        path: "/weeklyship/tracking",
        roles: ['superuser','admin']
      },
      {
        title: "ใส่เลขกล่อง",
        path: "/weeklyship/boxinsert",
        roles: ['superuser','admin']
      },
      {
        title: "ใส่น้ำหนัก (แอร์)",
        path: "/weeklyship/boxweightinsert",
        roles: ['superuser','admin']
      },
      {
        title: "แก้ไข/ลบ กล่องแอร์",
        path: "/weeklyship/air-manage",
        roles: ['superuser','admin']
      },
      {
        title: "จัดการกล่อง",
        path: "/weeklyship/action",
        roles: ['superuser','admin']
      },
      {
        title: "Composite Job",
        path: "/weeklyship/composite",
        roles: ['superuser','admin']
      },
      {
        title: "สร้างป้าย QR Code",
        path: "/label-generator",
        roles: ['superuser','admin']
      },
      {
        title: "สรุปกลุ่มจัดส่ง",
        path: "/weeklyship/shipment-group-summary",
        roles: ['superuser','admin']
      },
      {
        title: "นำเข้า iShip",
        path: "/weeklyship/iship-import",
        roles: ['superuser','admin']
      },
      {
        title: "รายการจาก LIFF",
        path: "/liff-submissions",
        roles: ['superuser','admin']
      },
      {
        title: "ใส่ต้นทุน Air",
        path: "/weeklyship/air-detail",
        roles: ['superuser','admin']
      },
      {
        title: "สรุปเงินแอร์",
        path: "/weeklyship/air-summary",
        roles: ['superuser','admin']
      },
      {
        title: "รายการมูลค่าสูง",
        path: "/weeklyship/high-value",
        roles: ['superuser','admin']
      },
      {
        title: "รายงานหมวดหมู่สินค้า",
        path: "/admin/category-report",
        roles: ['superuser'],
      },
    ],
  },
  {
    title: "ตั้งค่า",
    icon: Cog6ToothIcon,
    roles: ['superuser','admin'],
    childrens: [
      {
        title: "ธนาคาร",
        path: "/setting/bank",
        roles: ['superuser'],
      },
      {
        title: "เว็ปไซต์",
        path: "/setting/website",
        roles: ['superuser','admin']
      },
      {
        title: "Fee เว็บไซต์",
        path: "/setting/website-fee-exclusion",
        roles: ['superuser','admin']
      },
      {
        title: "ที่อยู่รับของ (คลัง)",
        path: "/setting/warehouse-receiving-address",
        roles: ['superuser','admin'],
      },
      {
        title: "บัตรกดเงิน",
        path: "/setting/travelcard",
        roles: ['superuser'],
      },
      {
        title: "เรทเริ่มต้น",
        path: "/setting/default-order",
        roles: ['superuser'],
      },
      {
        title: "รอบเรือ",
        path: "/setting/shipdate",
        roles: ['superuser','admin'],
      },
      {
        title: "รูปตาราง Landing",
        path: "/setting/landing-schedule",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ตัวเลือกค่าใช้จ่าย",
        path: "/setting/expense",
        roles: ['superuser'],
      },
      {
        title: "Test Mercari",
        path: "/setting/test",
        roles: ['superuser'],
      },
      {
        title: "ค่าส่งแอร์รายชนิด",
        path: "/setting/airitemtype",
        roles: ['superuser','admin'],
      },
      {
        title: "จัดการแบรนด์",
        path: "/setting/brand",
        roles: ['superuser','admin'],
      },
      {
        title: "ข้อมูล Admin",
        path: "/setting/admin",
        roles: ['superuser'],
      },
      {
        title: "KPI List",
        path: "/setting/kpi-list",
        roles: ['superuser'],
      },
      {
        title: "Tier Config",
        path: "/setting/tier-config",
        roles: ['superuser'],
      },
      {
        title: "Coupon",
        path: "/setting/coupon",
        roles: ['superuser'],
      },
      {
        title: "Agreement",
        path: "/setting/agreement",
        roles: ['superuser'],
      },
      {
        title: "Order By",
        path: "/setting/order-by",
        roles: ['superuser'],
      },
      {
        title: "Order Routing Rules",
        path: "/setting/order-routing-rules",
        roles: ['superuser'],
      },
      {
        title: "Routing Settings",
        path: "/setting/mercari-routing-settings",
        roles: ['superuser'],
      },
      {
        title: "Dispatch Bot",
        path: "/setting/dispatch",
        roles: ['superuser'],
      },
      {
        title: "Urgency Monitor",
        path: "/setting/merpay-urgency",
        roles: ['superuser'],
      },
    ],
  },
  {
    title: "Admin",
    icon: UserGroupIcon,
    roles: ['superuser', 'admin'],
    childrens: [
      {
        title: "บันทึก KPI",
        path: "/admin/kpi-record",
        roles: ['superuser'],
      },
      {
        title: "รายการพลาด",
        path: "/admin/admin-mistake",
        roles: ['superuser'],
      },
      {
        title: "มอบหมายงานพิเศษ",
        path: "/admin/special-task",
        roles: ['superuser'],
      },
      {
        title: "ดู KPI ของฉัน",
        path: "/admin/kpi-view",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ดูรายการ KPI",
        path: "/admin/kpi-list-view",
        roles: ['superuser', 'admin'],
      },
      {
        title: "บันทึก OT",
        path: "/admin/overtime",
        roles: ['superuser'],
      },
      {
        title: "บันทึก Leave",
        path: "/admin/leave",
        roles: ['superuser'],
      },
      {
        title: "สร้างสรุป KPI รายเดือน",
        path: "/admin/kpi-summary-generate",
        roles: ['superuser'],
      },
      {
        title: "จ่ายเงินเดือนพนักงาน",
        path: "/admin/salary-payment",
        roles: ['superuser'],
      },
      {
        title: "เอกสารภาษีประจำปี",
        path: "/admin/annual-tax-documents",
        roles: ['superuser'],
      },
      {
        title: "สร้างประกาศ",
        path: "/admin/announcement/create",
        roles: ['superuser'],
      },
      {
        title: "Feedback แชทของฉัน",
        path: "/chat-feedback",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ส่ง Feedback แชท",
        path: "/chat-feedback/import",
        roles: ['superuser'],
      },
      {
        title: "Dashboard Feedback แชท",
        path: "/chat-feedback/dashboard",
        roles: ['superuser'],
      },
    ],
  },
  {
    title: "บริษัท",
    icon: UserGroupIcon,
    roles: ['superuser'],
    childrens: [
      {
        title: "Company Info",
        path: "/customer-company-info",
        roles: ['superuser','admin']
      },
      {
        title: "Order",
        path: "/company/order/",
        roles: ['superuser'],
      },
      {
        title: "SKU Setting",
        path: "/company/sku",
        roles: ['superuser'],
      },
      {
        title: "Stock จัดซื้อ",
        path: "/company/stock/add",
        roles: ['superuser'],
      },
      {
        title: "Stock คงเหลือ",
        path: "/company/stock/balance",
        roles: ['superuser'],
      },
      {
        title: "Export รายเดือน",
        path: "/company/monthly-export",
        roles: ['superuser'],
      },
      {
        title: "หนังสือรับรอง 50 ทวิ",
        path: "/company/wht-certificate",
        roles: ['superuser'],
      },
      {
        title: "ค้างจ่ายรายเดือน",
        path: "/company/monthly-unpaid",
        roles: ['superuser'],
      },
      {
        title: "Accounting: เงินค้างส่ง 1 ม.ค. 2026",
        path: "/company/accounting/year-start-unshipped-beam",
        roles: ['superuser'],
      },
      {
        title: "บันทึกโอนตรง → เอกสาร",
        path: "/admin/transfer-backfill",
        roles: ['superuser'],
      },
    ],
  },
  {
    title: "เครื่องมือ",
    icon: WrenchScrewdriverIcon,
    roles: ['superuser', 'admin'],
    childrens: [
      {
        title: "Manual Upload รูป",
        path: "/util/manual-upload",
        roles: ['superuser', 'admin'],
      },
      {
        title: "สแกน Tracking JP",
        path: "/util/tracking-lookup",
        roles: ['superuser', 'admin'],
      },
      {
        title: "ประวัติการสแกน",
        path: "/util/scan-log",
        roles: ['superuser', 'admin'],
      },
      {
        title: "สถานะ Poller",
        path: "/admin/poller-health",
        roles: ['superuser'],
      },
    ],
  },
  {
    title: "โปรไฟล์",
    icon: UserIcon,
    path: "/userprofile",
    roles: ['superuser','admin','user'],
  },
];

export default menu;
